/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetOrgInvitesOptions, AdminGetOrgInvitesStatus200, AdminGetOrgInvitesStatus422 } from '../models/AdminGetOrgInvites'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetOrgInvites } from '../clients/axios/adminGetOrgInvites'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetOrgInvitesQueryKey = ({ path, query }: Omit<AdminGetOrgInvitesOptions, 'headers'>) => [{ url: '/admin/org/:org_id/invites', params: path }, ...(query ? [query] : [])] as const

type AdminGetOrgInvitesQueryKey = ReturnType<typeof adminGetOrgInvitesQueryKey>

export function adminGetOrgInvitesQueryOptions({ path, query }: AdminGetOrgInvitesOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetOrgInvitesQueryKey({ path, query })
  return queryOptions<AdminGetOrgInvitesStatus200, ResponseErrorConfig<AdminGetOrgInvitesStatus422>, AdminGetOrgInvitesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetOrgInvites({ ...config, path, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description Get all outstanding org invitations.
 * @summary Get Org Invites
 * {@link /admin/org/:org_id/invites}
 */
export function useAdminGetOrgInvites<TData = AdminGetOrgInvitesStatus200, TQueryData = AdminGetOrgInvitesStatus200, TQueryKey extends QueryKey = AdminGetOrgInvitesQueryKey>({ path, query }: { path: AdminGetOrgInvitesOptions['path'] | (() => AdminGetOrgInvitesOptions['path']); query?: AdminGetOrgInvitesOptions['query'] | (() => AdminGetOrgInvitesOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<AdminGetOrgInvitesStatus200, ResponseErrorConfig<AdminGetOrgInvitesStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path, query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetOrgInvitesQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetOrgInvitesQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetOrgInvitesStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
